import type { DocNode } from '@atlaskit/adf-schema/doc';

import type { GetConfluencePage } from '../../common/types';

export interface ConfluencePageResultInAdf {
	_links: {
		editui: string;
		tinyui: string;
		webui: string;
	};
	authorId: string;
	body: {
		atlas_doc_format?: {
			representation: string;
			value: string;
		};
	};
	createdAt: string;
	id: string;
	lastOwnerId: string;
	ownerId: string;
	parentId: string;
	parentType: string;
	position: number;
	spaceId: string;
	status: string;
	title: string;
	version: {
		authorId: string;
		createdAt: string;
		message: string;
		minorEdit: true;
		number: 19;
	};
}

export const getConfluencePageAdfFromApi = async ({
	cloudId,
	contentType,
	pageId,
	signal,
	product = 'confluence',
	experienceId = 'ai-issue-create',
}: GetConfluencePage): Promise<DocNode | undefined> => {
	try {
		const endpointAPI = contentType === 'blogpost' ? `blogposts` : `pages`;
		const response = await fetch(
			`/wiki/api/v2/${endpointAPI}/${pageId}?body-format=atlas_doc_format`,
			{
				method: 'GET',
				headers: {
					'Content-Type': 'application/json;charset=UTF-8',
					'X-Experience-Id': experienceId,
					'X-Product': product,
					'Atl-CloudId': cloudId,
				},
				credentials: 'include',
				signal,
			},
		);

		const data = await response.json();
		if (!data.body?.atlas_doc_format) {
			throw new Error('No atlas doc format found in confluence page');
		}

		return JSON.parse(data.body.atlas_doc_format.value) as DocNode;
	} catch (error: Error | unknown) {
		throw new Error('Request to get confluence page failed');
	}
};
